import { makeStyles } from '@material-ui/core';

import commonStyles from 'config/commonStyles';
import { theme } from 'config/theme';

export const useStyles = makeStyles({
    ...commonStyles,
    root: {
        height: 650,
    },
    logoContainer: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: 32,
        width: 32,
        borderRadius: 100,
        marginRight: 16,
    },
    disabledRow: {
        '& td:not(:last-child)': {
            opacity: 0.35,
        },
        '& td:last-child': {
            borderBottomColor: 'rgba(224, 224, 224, 0.35)',
        },
    },
    tableContainer: {
        position: 'relative',
        filter: 'none',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflowY: 'hidden',
    },
    smartFridgeLabel: {
        marginLeft: 15,
        height: 25,
    },
    input: {
        position: 'relative',
        '& .MuiInputLabel-formControl': {
            top: -7,
        },
        '& img': {
            position: 'absolute',
            top: '18px',
            right: '18px',
            cursor: 'pointer',
        },
        '& img.disabled-img': {
            cursor: 'auto',
        },
    },
    labelsModalInput: {
        '& .MuiInputBase-input': {
            padding: '17px 12px 17px',
        },
        '& .MuiInputAdornment-root.MuiInputAdornment-positionStart.MuiInputAdornment-filled': {
            marginTop: 0,
            marginRight: 15,
        },
        '& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)':
            {
                marginTop: 0,
                marginRight: 15,
            },
        '& .MuiInputAdornment-positionStart .MuiIconButton-label': {
            height: 32,
            width: 32,
            backgroundColor: theme.palette.common.white,
            borderRadius: 50,
        },
        '& .MuiInputAdornment-positionStart .MuiIconButton-label img': {
            maxHeight: 25,
            maxWidth: 25,
        },
    },
    errorMessage: {
        position: 'absolute',
        left: 10,
        top: 5,
        color: theme.palette.error.dark,
        fontSize: 12,
        zIndex: 1,
    },
    addButton: {
        width: 136,
        position: 'absolute',
        top: 15,
        right: 25,
    },
    removeCircle: {
        height: 20,
        width: 20,
    },
    cell: {
        '&:hover': {
            cursor: 'pointer',
        },
    },
    tableFilers: {
        padding: '10px 10px 0 15px',
    },
    tableGroupSeparator: {
        backgroundColor: theme.palette.secondary.light,
    },
});
